import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React from 'react';
import { styles } from './Button.styles.js';
import { classNames } from '../../../utils/common/styling.js';
import MUIButton from '@mui/material/ButtonBase';

var Button = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.borderRadius, borderRadius = _d === void 0 ? "rounded" : _d, className = _a.className, rest = __rest(_a, ["children", "color", "size", "borderRadius", "className"]);
    return (React.createElement(MUIButton, __assign({ classes: {
            root: classNames(className, styles.btn, styles["btn-color-".concat(color)], styles["btn-size-".concat(size)], styles["btn-borderRadius-".concat(borderRadius)]),
        } }, rest), children));
};

export { Button as default };
//# sourceMappingURL=Button.js.map
